import React from "react";

type NewrelicProps = {
  size?: string;
};

const Newrelic = ({ size = "32px" }: NewrelicProps) => (
  <svg
    width="19"
    height="23"
    viewBox="0 0 19 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ width: size, height: size }}
  >
    <path
      d="M15.3646 7.97813V15.0219L9.5343 18.5437V23L19.0686 17.25V5.75L15.3646 7.97813Z"
      fill="#00AC69"
    />
    <path
      d="M9.5343 4.45625L15.3646 7.97812L19 5.75L9.5343 0L0 5.75L3.63538 7.97812L9.5343 4.45625Z"
      fill="#1CE783"
    />
    <path
      d="M5.83033 13.7281V20.7719L9.4657 23V11.5L0 5.75V10.2062L5.83033 13.7281Z"
      fill="white"
    />
  </svg>
);

export default Newrelic;
